<template>
  <div class="layout-box-header-right-user-mask" v-if="visible">
    <div class="layout-box-header-right-user-mask-box">
      <p>{{ title }}</p>
      <el-button type="primary" style="width: 100%;" @click="close">{{ $i18n.$t('确定') }}</el-button>
    </div>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
export default {
  name: 'empty-dialog',
  props: {
    title: {
      type: String,
      default: i18n.$t('暂无数据~')
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.layout-box-header-right-user-mask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &-box {
    padding: 30px;
    border-radius: 10px;
    background-color: #ffffff;
    p {
      font-size: 18px;
      color: #333333;
      margin-bottom: 20px;
    }
  }
}
</style>
